import React, { Component } from 'react'
import { List } from 'material-ui/List'

import RoomItem from '../room-item'
import CardHalfHeight from './../cards/CardHalfHeight'
import Subheader from 'material-ui/Subheader';

import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow} from 'material-ui/Table';

const styles = {
  thead: {
    padding: 0,
    whiteSpace: 'normal'

},
theadfull: {
    overflowX: 'scroll'
},
    tbody: {
        textAlign: 'center',
        overflowX: 'scroll'
    },
    scrolltable: {
        tableLayout: 'inherit'
    },
    wholetable: {
        overflowX: 'scroll'
    }
}



function RoomList({ currentUser, rooms, onRoomClick, preferenceAlreadyAdded, preferenceRankChange, preferenceGroupSizeMismatch, confirmedGroup, subHeader, isPreferenceList}) {

  // shouldComponentUpdate(nextProps) {
  //   return nextProps.rooms !== rooms
  // }
    let disableLeaderActionButton = false
    if (confirmedGroup) {
      disableLeaderActionButton = confirmedGroup.hasSubmittedPreferences
    }

    if (isPreferenceList) {
      let roomItems = rooms.map((room, index) => {
        return (
          <RoomItem
            key={room.key}
            room={room}
            onRoomClick={onRoomClick}
            preferenceRankChange={preferenceRankChange}
            confirmedGroup={confirmedGroup}
            isPreferenceItem={isPreferenceList}
            rank={index + 1}
            renderWithLeaderAction={currentUser && currentUser.isGroupLeader && currentUser.isInConfirmedGroup}
            disableLeaderActionButton={disableLeaderActionButton}
          />
        )
      })
      return (
        <Table selectable={false} style={styles.scrolltable}>
          <TableHeader displaySelectAll={false} enableSelectAll={false}>
            <TableRow>
              <TableHeaderColumn>Building</TableHeaderColumn>
              <TableHeaderColumn>Room</TableHeaderColumn>
              <TableHeaderColumn>Capacity</TableHeaderColumn>
              <TableHeaderColumn>Gender Restrictions</TableHeaderColumn>
              <TableHeaderColumn>Availability</TableHeaderColumn>
              <TableHeaderColumn tooltip="Click A Ranking To Edit">Rank</TableHeaderColumn>
              {currentUser && currentUser.isGroupLeader && currentUser.isInConfirmedGroup ? <TableHeaderColumn>Remove Preference</TableHeaderColumn>: null}
             </TableRow>
          </TableHeader>
          <TableBody>
            {roomItems}
          </TableBody>
        </Table>


      )
    }
    else {
      let roomItems = rooms.map((room) => {
        return (
          <RoomItem
            key={room.key}
            room={room}
            onRoomClick={onRoomClick}
            preferenceAlreadyAdded={preferenceAlreadyAdded}
            preferenceGroupSizeMismatch={preferenceGroupSizeMismatch}
            confirmedGroup={confirmedGroup}
            isPreferenceItem={isPreferenceList}
            renderWithLeaderAction={currentUser && currentUser.isGroupLeader && currentUser.isInConfirmedGroup}
            disableLeaderActionButton={disableLeaderActionButton}
            currentUserGender={currentUser.gender}
          />
        )
      })
      return (
        <Table selectable={false} style={styles.wholetable}>
          <TableHeader displaySelectAll={false} enableSelectAll={false}>
            <TableRow style={styles.theadfull}>
              <TableHeaderColumn style={styles.thead}>Building</TableHeaderColumn>
              <TableHeaderColumn style={styles.thead}>Room</TableHeaderColumn>
              <TableHeaderColumn style={styles.thead}>Capacity</TableHeaderColumn>
              <TableHeaderColumn style={styles.thead}>Gender Restrictions</TableHeaderColumn>
              <TableHeaderColumn style={styles.thead}>Availability</TableHeaderColumn>
              {currentUser && currentUser.isGroupLeader && currentUser.isInConfirmedGroup ? <TableHeaderColumn style={styles.thead}>Add Preference</TableHeaderColumn>: null}
            </TableRow>
          </TableHeader>
          <TableBody style={styles.tbody}>
            {roomItems}
          </TableBody>
        </Table>


      )
    }
}

export default RoomList



// WEBPACK FOOTER //
// ./src/views/components/room-list/index.js